import services from '@/services';
import moment from 'moment';

const state = {
  items: [],
  data: {},
};

const mutations = {
  setWithdrawItem: (state, items) => {
    state.items = items?.map((item) => {
      item.approved_date = moment(item.approved_date).format('DD MMM YYYY HH:mm')
      item.created_date = moment(item.created_date).format('DD MMM YYYY HH:mm')
      item.updated_date = moment(item.updated_date).format('DD MMM YYYY HH:mm')

      return item
    })
  }
}

const actions = {
  all({ commit, dispatch }, param) {
    services.setHeader();
    dispatch("setLoadingTable", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("sellerwithdraw", param)
        .then((response) => {
          commit('setWithdrawItem', response.data.data.items)
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingTable", false, { root: true })
        })
    });
  },
  export({dispatch}, param) {
    param.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("seller-withdraw/download", param)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  approve({ dispatch }, body) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("seller-withdraw-approve", body)
        .then((response) => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    }).finally(()=>{
      dispatch("setLoadingGlobal", false, { root: true })
    })
  },
  reject({ dispatch }, body) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("seller-withdraw-reject", body)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>[
          dispatch("setLoadingGlobal", false, { root: true })
        ])
    });
  },
  show({dispatch}, withdrawId) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get(`seller-withdraw/${withdrawId}`)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  setting({ dispatch }) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("withdraw-setting")
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  updateSetting({ dispatch }, body) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("withdraw-setting", body)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
